<template>
  <naj-box :title="local.bankruptcy.creditorForm.title">
    <bankrupt-debts-form
      :form-model="formModel"
      :loading="false"
      :identity-form-disabled="isIdentityFormDisabled"
      :view-mode="isViewMode || auditConfirmations[`flag_${mainRequestAuditFlag.creditorDetailsConfirmation}`]"
      :min-debt-amount="50000"
      :apply-min-debt-amount="applyMinDebtAmount"
      :request-owner-type-id="mainRequest.requestOwnerTypeId"
    ></bankrupt-debts-form>
    <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.creditorDetailsConfirmation"></audit-confirmation-flag-checkbox>
  </naj-box>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState, mapGetters, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');
import BankruptDebtsForm from './../request-details/bankrupt-debts-tab/bankrupt-debts-form.vue';
import { paymentStatusEnum, procedureTypeEnum, mainRequestAuditFlag } from '@/modules/bankruptcy/helpers/enum';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';

export default {
  name: 'CreditorForm',
  inject: ['$validator'],
  components: {
    BankruptDebtsForm,
    AuditConfirmationFlagCheckbox,
  },
  data() {
    return {
      paymentStatusEnum,
      procedureTypeEnum,
      mainRequestAuditFlag,
    };
  },
  computed: {
    applyMinDebtAmount() {
      return this.mainRequest.procedureTypeId == procedureTypeEnum.liquidation;
    },
    ...mapState({
      formModel: state => state.creditor,
      mainRequest: state => state.mainRequest,
      auditConfirmations: state => state.auditConfirmations,
    }),
    ...mapLUTState(['paymentStatuses']),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
    ]),
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
    isIdentityFormDisabled() {
      return this.isViewMode || this.formModel.objectKey != undefined;
    },
  },
  created() {
    this.getRequestCreditorDetails(this.requestObjectKey);
  },
  methods: {
    ...mapActions([
      'getRequestCreditorDetails',
    ]),
  },
};
</script>

<style lang="scss">
</style>
